(function () {
  const STAR_FULL = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" aria-hidden="true"><rect width="22" height="22" fill="#00B67A"/><path d="M11 3.5L13.09 8.26L18.25 8.78L14.38 12.24L15.5 17.3L11 14.67L6.5 17.3L7.62 12.24L3.75 8.78L8.91 8.26L11 3.5Z" fill="#fff"/></svg>';
  const STAR_EMPTY = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" aria-hidden="true"><rect width="22" height="22" fill="#DCDCE6"/><path d="M11 3.5L13.09 8.26L18.25 8.78L14.38 12.24L15.5 17.3L11 14.67L6.5 17.3L7.62 12.24L3.75 8.78L8.91 8.26L11 3.5Z" fill="#fff"/></svg>';

  function buildStars(rating) {
    const r = parseInt(rating, 10) || 0;
    let html = '<span class="review-modal__stars" style="display:inline-flex;gap:2px">';
    for (let i = 1; i <= 5; i++) {
      html += i <= r ? STAR_FULL : STAR_EMPTY;
    }
    html += `</span><strong style="font-weight:700">${r}/5</strong>`;
    return html;
  }

  function findModalForButton(btn) {
    // Look up to the section to find the matching modal
    const section = btn.closest('[id^="review-bar-"]');
    if (!section) return null;
    const sectionId = section.id.replace('review-bar-', '');
    return document.getElementById(`ReviewModal-${sectionId}`);
  }

  let lastFocused = null;

  function openModal(btn) {
    const modal = findModalForButton(btn);
    if (!modal) return;

    const card = btn.closest('.review-card');
    const fullTemplate = card?.querySelector('[data-review-text-full]');
    const fullText = fullTemplate ? fullTemplate.innerHTML : (card?.querySelector('[data-review-text-truncated]')?.textContent || '');

    const author = btn.dataset.reviewAuthor || '';
    const rating = btn.dataset.reviewRating || '0';
    const date = btn.dataset.reviewDate || '';
    const expDate = btn.dataset.reviewExperienceDate || '';

    modal.querySelector('[data-modal-rating]').innerHTML = buildStars(rating);
    modal.querySelector('[data-modal-author]').textContent = author;

    const dateEl = modal.querySelector('[data-modal-date]');
    if (date) {
      let dateText = `Avis du ${date}`;
      if (expDate) dateText += `, suite à une expérience du ${expDate}`;
      dateEl.textContent = dateText;
      dateEl.hidden = false;
    } else {
      dateEl.hidden = true;
    }

    modal.querySelector('[data-modal-text]').textContent = fullText.trim();

    lastFocused = document.activeElement;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('review-modal-open');

    // Focus close button
    const closeBtn = modal.querySelector('.review-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('review-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  // Delegate click handlers
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-review-open]');
    if (openBtn) {
      e.preventDefault();
      openModal(openBtn);
      return;
    }

    const closeTarget = e.target.closest('[data-review-modal-close]');
    if (closeTarget) {
      const modal = closeTarget.closest('.review-modal');
      if (modal) closeModal(modal);
    }
  });

  // Esc key
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.review-modal[aria-hidden="false"]').forEach(closeModal);
  });
})();